import e from "./ghl-ui.es1506.js";
import a from "./ghl-ui.es1466.js";
function u(t) {
  a(1, arguments);
  var r = e(t);
  return r.setHours(0, 0, 0, 0), r;
}
export {
  u as default
};
